var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FCFaqCard',{attrs:{"code-id":_vm.codeId,"faq":_vm.faq}})}
var staticRenderFns = []

export { render, staticRenderFns }